export const displayConfirmationLeavingItinerarySelector = ({displayConfirmationLeavingItinerary}) => displayConfirmationLeavingItinerary